module.exports = __webpack_public_path__ + "static/media/Placaj-Ceramic-Klinker-250-X-65-X-10---Mediterana-(09).3fdfec1d.jpg";